module.exports = __webpack_public_path__ + "static/media/mobile-banner-en.904acb34.jpg";